// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Belt_Option from "../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as DeccoUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/DeccoUtils.mjs";
import * as MediaEntityMapper$PorterinFeature from "../../../../shared/media/domain/entity-mappers/MediaEntityMapper.mjs";
import * as OrderHistoryStore$PorterinFeature from "../store/OrderHistoryStore.mjs";
import * as OrderHistoryContentApiModel$PorterinFeature from "../api-model/OrderHistoryContentApiModel.mjs";

function downloadAppBannerToEntity(banner) {
  return {
          text: banner.text,
          cta: {
            label: banner.cta.label,
            href: Belt_Option.getWithDefault(banner.cta.href, "")
          },
          image: MediaEntityMapper$PorterinFeature.getImageFromLongImage(banner.image)
        };
}

function apiModelToEntity(res) {
  return {
          heading: res.data.attributes.heading,
          download_app_banner: downloadAppBannerToEntity(res.data.attributes.download_app_banner),
          track_order_button_text: Belt_Option.getWithDefault(res.data.attributes.track_order_button_text, OrderHistoryStore$PorterinFeature.track_order_button)
        };
}

function execute(json) {
  return apiModelToEntity(DeccoUtils$Catalyst.resolveResult(OrderHistoryContentApiModel$PorterinFeature.t_decode(json), "OrderHistoryEntityMapper.res"));
}

export {
  downloadAppBannerToEntity ,
  apiModelToEntity ,
  execute ,
}
/* DeccoUtils-Catalyst Not a pure module */
